/* Hojas de un texto largo.
   El campo sigue siendo UNA sola columna de texto: las hojas van dentro del
   mismo HTML, separadas por un comentario <!--hoja:Nombre-->. Así no hay que
   migrar nada y lo escrito antes de esto se sigue leyendo tal cual: un texto
   sin marcas es, simplemente, la primera hoja. */

export interface Hoja { nombre: string; html: string }

export const HOJA_DEFECTO = 'Hoja 1';
const MARCA = /<!--hoja:([\s\S]*?)-->/;
const MARCA_G = /<!--hoja:([\s\S]*?)-->/g;

/* El nombre viaja dentro de un comentario HTML: sin <, > ni -- no puede
   cerrarlo antes de tiempo ni romper el resto del texto. */
export function limpiarNombre(n: string): string {
  return (n || '').replace(/[<>]/g, '').replace(/-{2,}/g, '-').trim().slice(0, 28);
}

export function parseHojas(raw: string): Hoja[] {
  const s = raw || '';
  if (!MARCA.test(s)) return [{ nombre: HOJA_DEFECTO, html: s }];
  const partes = s.split(MARCA_G);
  const hojas: Hoja[] = [];
  // Texto anterior a la primera marca: es de cuando el campo no tenía hojas.
  if ((partes[0] || '').trim()) hojas.push({ nombre: HOJA_DEFECTO, html: partes[0] });
  for (let i = 1; i < partes.length; i += 2) {
    hojas.push({
      nombre: limpiarNombre(partes[i]) || `Hoja ${hojas.length + 1}`,
      html: partes[i + 1] || '',
    });
  }
  return hojas.length ? hojas : [{ nombre: HOJA_DEFECTO, html: '' }];
}

export function serializeHojas(hojas: Hoja[]): string {
  const hs = hojas.length ? hojas : [{ nombre: HOJA_DEFECTO, html: '' }];
  // Una sola hoja sin renombrar se guarda como siempre, sin marcas.
  if (hs.length === 1 && hs[0].nombre === HOJA_DEFECTO) return hs[0].html || '';
  return hs
    .map(h => `<!--hoja:${limpiarNombre(h.nombre) || HOJA_DEFECTO}-->${h.html || ''}`)
    .join('');
}

const soloTexto = (html: string) => (html || '').replace(/<[^>]*>/g, '').trim();

export const hojaVacia = (h: Hoja) => !soloTexto(h.html);

/* Lo que se le manda a la IA: el contenido de todas las hojas, cada una con su
   nombre por delante cuando hay más de una. */
export function textoHojas(raw: string): string {
  const hs = parseHojas(raw).filter(h => !hojaVacia(h));
  if (!hs.length) return '';
  if (hs.length === 1) return soloTexto(hs[0].html);
  return hs.map(h => `[${h.nombre}]\n${soloTexto(h.html)}`).join('\n\n');
}

export function nombreNuevaHoja(hojas: Hoja[]): string {
  const usados = new Set(hojas.map(h => h.nombre));
  let n = hojas.length + 1;
  while (usados.has(`Hoja ${n}`)) n++;
  return `Hoja ${n}`;
}
